import { t } from 'i18next';
import React from 'react';
import Layout from '~/components/Layout';

const Dashboard: React.FunctionComponent = () => {

  return (
    <Layout title={t('Dashboard')}>
      <div>
      </div>
    </Layout>
  );
};

export default Dashboard;
